import { render } from "./CommissionDetail.vue?vue&type=template&id=d72558fa&scoped=true"
import script from "./CommissionDetail.vue?vue&type=script&lang=js"
export * from "./CommissionDetail.vue?vue&type=script&lang=js"

import "./CommissionDetail.vue?vue&type=style&index=0&id=d72558fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d72558fa"]])

export default __exports__